module.exports = {
  email: 'tejesh.gill@gmail.com',

  socialMedia: [
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/tejeshwargill',
    },
    {
      name: 'GitHub',
      url: 'https://github.com/TejeshwarGill',
    },
    {
      name: 'Medium',
      url: 'https://medium.com/@tejeshwargill',
    },
    {
      name: 'StackOverflow',
      url: 'https://stackoverflow.com/users/1388966/ironmangill',
    },
  ],

  navLinks: [
    {
      name: 'About',
      url: '/#about',
    },
    {
      name: 'Experience',
      url: '/#jobs',
    },
    {
      name: 'Highlights',
      url: '/#projects',
    },
    {
      name: 'Speaking',
      url: '/#mentorships',
    },
    {
      name: 'Education',
      url: '/#education',
    },
    {
      name: 'Contact',
      url: '/#contact',
    },
  ],

  colors: {
    green: '#64ffda',
    navy: '#0a192f',
    darkNavy: '#020c1b',
  },

  srConfig: (delay = 200, viewFactor = 0.25) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
